module.exports = __webpack_public_path__ + "img/0Q3A5801_Mockup.464f7644.jpg";